// components
import { GridCompact6 } from 'components/shared/Grid/Grid.components';
import SectionHeader from '../SectionHeader/SectionHeader';
import ControlledFavoriteAutocomplete from 'components/shared/ControlledFields/ControlledFavoriteAutocomplete';
import WorkplaceSelect from './components/WorkplaceSelect/WorkplaceSelect';

// styles
import { SpacedBox } from '../../AppointmentForm.styles';

// hooks
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { RefObject, useMemo } from 'react';
import { useActivitySuggestions } from './useActivitySuggestions';

// types
import { AppointmentFormFieldData } from '../../AppointmentForm.types';

// utils
import { getEntityIcon } from 'components/mrp/mrp.utils';

type WhatWhereSectionProps = {
  activityFieldRef?: RefObject<HTMLInputElement | null>;
};

const WhatWhereSection = ({ activityFieldRef }: WhatWhereSectionProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });

  const { control } = useFormContext<AppointmentFormFieldData>();

  const employees = useWatch({ control, name: 'planEntities.EMPLOYEE' });

  const employeeIds: string[] | undefined = useMemo(
    () =>
      employees?.map((e) => e.entityId).filter(Boolean) as string[] | undefined,
    [employees]
  );

  const {
    displayOptions,
    displaySuggestedOptions,
    shouldShowMoreButton,
    shouldDisableFavoriteFilter,
    setShowOtherActivities
  } = useActivitySuggestions({ employeeIds });

  return (
    <GridCompact6>
      <SectionHeader
        label={t('whatAndWhere')}
        icon={getEntityIcon('WORKPLACE', undefined, 'MEDIUM')}
      />
      <SpacedBox>
        <ControlledFavoriteAutocomplete
          name="activity"
          control={control}
          innerRef={activityFieldRef}
          label={t('activity')}
          options={displayOptions}
          suggestedOptions={displaySuggestedOptions}
          optionLabelProp={['name', 'code']}
          type="ACTIVITY"
          idProperty={'entityId'}
          fullWidth
          variant="outlined"
          disableFavoriteFilter={shouldDisableFavoriteFilter}
          showMoreButton={shouldShowMoreButton}
          showMoreText={t('showAllActivities')}
          onShowMore={() => setShowOtherActivities(true)}
          onClose={() => setShowOtherActivities(false)}
        />
      </SpacedBox>

      <SpacedBox>
        <WorkplaceSelect />
      </SpacedBox>
    </GridCompact6>
  );
};

export default WhatWhereSection;
